import axios from '../../axios'

export default {
  getUsers () {
    return axios.get('users')
  },
  getUserEmail (userId) {
    return axios.get('users/' + userId + '/emails')
  },
  putUserEmails (userEmailObject) {
    return axios.post('users/' + userEmailObject.UserId + '/emails', userEmailObject)
    /*
    {
      "UserId": 1073,
      "Email": "name@strukton.com"
    }
    */
  },
  resetDisclaimer (userId) {
    return axios.get('users/' + userId + '/resetdisclaimer')
  },
  deleteUserEmail (userEmailObject) {
    return axios.delete('users/' + userEmailObject.UserId + '/emails/' + userEmailObject.Id)
  },
  getUser (id) {
    return axios.get('users/' + id)
  },
  async postUser (user) { // also used for adding
    const result = await axios.post('users/', user)
    return result
  },
  editUser (user) { // also used for adding
    return axios.put('users/' + user.UserV61id, user)
  },
  deleteUser (id) {
    return axios.delete('users/' + id)
  },
  getUserAlarmSettings (id) {
    return axios.get('users/' + id + '/alarmsettings')
  },
  async saveUserAlarmSettings (alarmSettings, id) {
    const result = await axios.post('users/' + id + '/alarmsettings', alarmSettings)
    return result
  },
  async publishAllActiveUsers () {
    const result = await axios.post('users/publish-all')
    return result
  }
}



// WEBPACK FOOTER //
// ./src/services/api/UsersApi.js